const Footer = () => {
  return (
    <>
      {/* footer copyright */}
      <div className="footer-copyright text-center pt-25 pb-25">
        <span>
          © Copyright <span className="fw-bold">{ (new Date().getFullYear()) }</span> - Victorien ANDRIANASOAVINA
        </span>
      </div>
    </>
  );
};

export default Footer;
